import React from "react";
import DashboardLayout from "../../../Layout/DashboardLayout";
import DashboardHeader from "../../../Components/DashboardHeader";
import { Link, useParams } from "react-router-dom";
import { useGetRolesQuery } from "../../../hooks/AdminManagement/useGetRolesQuery";
import Scaffold from "../../../Components/Scaffold";
import { useGetAdminsQuery } from "../../../hooks/AdminManagement/useGetAdminsQuery";
import Loader from "../../../Components/Loader";
import { Avatar } from "antd";
import NewRoleForm from "./components/NewRoleForm";
import EditRoleForm from "./components/EditRoleForm";

interface Items {
  email: string;
  firstName: string;
  lastName: string;
  role: Role;
  passwordChangedAt?: null;
  isSuspended: boolean;
  isDeleted: boolean;
  gender: string;
  phoneNumber: string;
  phoneCountryCode: string;
  lastLogin: string;
  createdBy: string;
  createdAt: string;
  updatedAt: string;
  id: string;
}
export interface Role {
  name: string;
  description: string;
  key: string;
  permission?: string[] | null;
  id: string;
}

const EditRole = () => {
  const Cancel = require("../../../assets/cancel.png");
  const Check = require("../../../assets/check.png");
  const { id } = useParams();
  const imageLink = "https://via.placeholder.com/50";

  const { data, isPending: isLoadingRoles } = useGetRolesQuery(id);
  const { data: admin, isPending: isLoadingAdmin } = useGetAdminsQuery({
    role: data?.data?.id,
  });
  return (
    <DashboardLayout title="Admin Management" back={false}>
      <div className="pt-[15px] pl-[15px] pr-[40px]">
        <DashboardHeader
          firstTitle={"Admin Management"}
          secondTitle={"Edit Role"}
        ></DashboardHeader>
        <EditRoleForm />
        {/* <div className="mt-[20px] mx-[20px]">
          {isLoadingRoles && <Loader />}
        </div> */}
        {/* {data?.data && !isLoadingRoles && (
          <div className="pt-[15px] pl-[15px] pr-[40px]">
            <h3 className="text-black text-[20px]">
              {data && data?.data?.name}
            </h3>
            <div className="flex mt-[10px] gap-[23px]">
              <div className="w-6/12 border-r-[1px] border-[#eeeeee] pr-[23px]">
                <Scaffold left="Description">
                  <p className="px-[10px] text-[#a8a8a8]">
                    {data && data?.data?.description}
                  </p>
                </Scaffold>
                <Scaffold left="Access">
                  <div className="px-[10px]">
                    {data &&
                      data?.data?.permission &&
                      data?.data?.permission.map(
                        ({
                          module,
                          update,
                          create,
                          delete: canDelete,
                          read,
                          id,
                        }: {
                          module: any;
                          update: boolean;
                          create: boolean;
                          read: boolean;
                          delete: boolean;
                          id: string;
                        }) => (
                          <div key={id} className="flex mb-3 items-center">
                            <div className="w-4/12 text-[#a8a8a8]">
                              {module.name}
                            </div>
                            <div className="w-2/12">
                              <img
                                src={create === true ? Check : Cancel}
                                alt=""
                                className="h-[15px] mx-auto"
                              />
                            </div>
                            <div className="w-2/12">
                              <img
                                src={read === true ? Check : Cancel}
                                alt=""
                                className="h-[15px] mx-auto"
                              />
                            </div>
                            <div className="w-2/12">
                              <img
                                src={update === true ? Check : Cancel}
                                alt=""
                                className="h-[15px] mx-auto"
                              />
                            </div>
                            <div className="w-2/12">
                              <img
                                src={canDelete === true ? Check : Cancel}
                                alt=""
                                className="h-[15px] mx-auto"
                              />
                            </div>
                          </div>
                        )
                      )}
                  </div>
                </Scaffold>
              </div>
              <div className="w-6/12">
                <Scaffold left="Admins with Access">
                  {isLoadingAdmin && <Loader />}
                  <div className="px-[10px]">
                    {!isLoadingAdmin && admin?.data?.docs.length === 0 && (
                      <div className="text-center py-[20xp] mx-auto flex">
                        No Admin assigned to this role
                      </div>
                    )}
                    {!isLoadingAdmin &&
                      admin?.data?.docs.map((item: Items) => (
                        <div className="flex gap-2 mb-2" key={item?.id}>
                          <Avatar
                            style={{
                              backgroundColor: "#562B00",
                              verticalAlign: "middle",
                            }}
                            size="large"
                          >
                            {item && item?.firstName.charAt(0)}
                          </Avatar>
                          <div className="flex-1">
                            <div className="flex justify-between items-center">
                              <span>
                                <h3>
                                  {item?.firstName + " " + item?.lastName}
                                </h3>
                                <div className="text-[#a8a8a8]">
                                  {item?.email}
                                </div>
                              </span>
                              <Link to={`/admin-management/user/${item?.id}`}>
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  strokeWidth={1.5}
                                  stroke="currentColor"
                                  className="size-6"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M13.5 6H5.25A2.25 2.25 0 0 0 3 8.25v10.5A2.25 2.25 0 0 0 5.25 21h10.5A2.25 2.25 0 0 0 18 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                                  />
                                </svg>
                              </Link>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </Scaffold>
              </div>
            </div>
          </div>
        )} */}
        {/* <div className="flex gap-2">
          <div className="w-6/12 mt-[20px] mb-[29px] border-r-[1px] border-[#a8a8a8] pr-[30px] mr-[30px]">
            <div className="flex gap-3 mb-3">
              <img
                src="https://via.placeholder.com/500"
                alt=""
                className="h-[55px] w-[55px] rounded-full"
              />
              <div>
                <h3 className="flex">
                  <span className="text-black font-bold">
                    {data && data?.data?.firstName + ' ' + data?.data?.lastName}
                  </span>
                  <span className="ml-3 px-[4px] py-[2px] bg-green-200 rounded-md text-green-600 text-[13px]">
                    Available
                  </span>
                </h3>
                <p className="text-[#a8a8a8] text-[15px]">
                  ID: #{data?.data?.id}
                </p>
              </div>
            </div>
            <Scaffold
              left="User information"
              right={
                <button className="text-orange flex gap-2 items-center">
                  <EditIcon />
                  Edit Information
                </button>
              }
            >
              <div className="flex mb-4">
                <div className="w-5/12 text-[#a8a8a8]">First Name</div>
                <div className="w-7/12">{data && data?.data?.firstName}</div>
              </div>
              <div className="flex mb-4">
                <div className="w-5/12 text-[#a8a8a8]">Last Name</div>
                <div className="w-7/12">{data && data?.data?.lastName}</div>
              </div>
              <div className="flex mb-4">
                <div className="w-5/12 text-[#a8a8a8]">Email Address</div>
                <div className="w-7/12">{data && data?.data?.email}</div>
              </div>
              <div className="flex mb-4">
                <div className="w-5/12 text-[#a8a8a8]">Phone Number</div>
                <div className="w-7/12">0{data && data?.data?.phoneNumber}</div>
              </div>
              <div className="flex mb-4">
                <div className="w-5/12 text-[#a8a8a8]">Gender</div>
                <div className="w-7/12">
                  {data && data?.data?.gender === ''
                    ? 'n/a'
                    : data?.data?.gender}
                </div>
              </div>
              <div className="flex mb-4">
                <div className="w-5/12 text-[#a8a8a8]">Date of Birth</div>
                <div className="w-7/12">n/a</div>
              </div>
              <div className="flex mb-4">
                <div className="w-5/12 text-[#a8a8a8]">Nationality</div>
                <div className="w-7/12">n/a</div>
              </div>
            </Scaffold>
            <Scaffold left="Assigned Vehicle Information">
              <div className="flex mb-4">
                <div className="w-5/12 text-[#a8a8a8]">Vehicle Type</div>
                <div className="w-7/12">Sedan</div>
              </div>
              <div className="flex mb-4">
                <div className="w-5/12 text-[#a8a8a8]">Registration Number</div>
                <div className="w-7/12">ABC-1234</div>
              </div>
              <div className="flex mb-4">
                <div className="w-5/12 text-[#a8a8a8]">Vehicle Color</div>
                <div className="w-7/12">White</div>
              </div>
              <div className="flex mb-4">
                <div className="w-5/12 text-[#a8a8a8]">Vehicle Condition</div>
                <div className="w-7/12">Good</div>
              </div>
              <div className="flex mb-4">
                <div className="w-5/12 text-[#a8a8a8]">Milelage</div>
                <div className="w-7/12">45,000 KM</div>
              </div>
              <div className="flex mb-4">
                <div className="w-5/12 text-[#a8a8a8]">
                  Insurance Expiry Date
                </div>
                <div className="w-7/12">August 16 2027</div>
              </div>
              <div className="flex mb-4">
                <div className="w-5/12 text-[#a8a8a8]">
                  Last Maintenance Date
                </div>
                <div className="w-7/12">March 28 2024</div>
              </div>
            </Scaffold>
          </div>
          <div className="w-6/12">
            <Scaffold left="Document 1">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Non
              eveniet nostrum dolorum enim ea fugit maiores consectetur officiis
              dolorem numquam. Beatae cupiditate maiores soluta officiis ut
              suscipit perspiciatis corrupti placeat.
            </Scaffold>
            <Scaffold left="Document 2">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Non
              eveniet nostrum dolorum enim ea fugit maiores consectetur officiis
              dolorem numquam. Beatae cupiditate maiores soluta officiis ut
              suscipit perspiciatis corrupti placeat.
            </Scaffold>
            <Scaffold
              left="Order History"
              right={
                <button className="bg-[#F3F3F3] rounded-md p-3 text-[12px]">
                  View All
                </button>
              }
            >
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Non
              eveniet nostrum dolorum enim ea fugit maiores consectetur officiis
              dolorem numquam. Beatae cupiditate maiores soluta officiis ut
              suscipit perspiciatis corrupti placeat.
            </Scaffold>
          </div>
        </div> */}
      </div>
    </DashboardLayout>
  );
};

export default EditRole;

const EditIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      strokeWidth={1.5}
      stroke="currentColor"
      className="size-6"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125"
      />
    </svg>
  );
};
